import { render, staticRenderFns } from "./PageComisionEquipo.vue?vue&type=template&id=0d68abd8&"
import script from "./PageComisionEquipo.vue?vue&type=script&lang=js&"
export * from "./PageComisionEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports